import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/core/services/api/bitf-api.service';

@Injectable({
  providedIn: 'root',
})
export class DietTypeService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('diet-type', injector);
  }
}
